import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { EmployerGroupService } from './employergroup.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-employergroup',
  templateUrl: './employergroup.component.html',
  styleUrls: ['./employergroup.component.scss']
})
export class EmployergroupComponent implements OnInit, OnDestroy {
  employersList: string[];
  employersListOptions: string[];
  @ViewChild(MatAutocompleteTrigger, { static: true }) employersInput: MatAutocompleteTrigger;
  autoCompleteFormControl = new FormControl();
  autoCompleteSubscription;
  employerErrorMsg: string;
  constructor(private employerGroupService: EmployerGroupService, private router: Router) {
    this.autoCompleteSubscription = this.autoCompleteFormControl.valueChanges.subscribe(value => {
      this.employersListOptions = value && value.length > 2 ? this._filter(value) : [];
    });
    this.getEmployers();
   }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.autoCompleteSubscription) {
      this.autoCompleteSubscription.unsubscribe();
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (filterValue.length >= 3) {
        return this.employersList.filter(data => data.toLowerCase().indexOf(filterValue) === 0);
    }

  }

  getEmployers() {
    this.employerGroupService.getEmployers().subscribe(data => {
      this.employersList = data.employers;
    });
  }

  getMemberNetwork() {
    if(this.autoCompleteFormControl.value && this.employersList.indexOf(this.autoCompleteFormControl.value) > -1) {
      this.router.navigate(['find'], { queryParams: { type: 'employer', network:  this.autoCompleteFormControl.value} });
    } else if(!this.autoCompleteFormControl.value) {
      this.employerErrorMsg = 'Please select a Company Name' ;
    } else {
      this.employerErrorMsg = 'Error loading values. Please try again.';
    }
  }
}
